export default {
  header: 'Nowe zamówienia wstrzymane',
  text: 'Dotknij gdziekolwiek, aby przywrócić',
};
